import type { IChipEditorModel } from '@/interfaces/models';
import type { TileInstance } from '@/models/tiles/TileInstance';
import { ActionType } from '@/models/HistoryModel';
import { Point } from '@/models/Point';
import { deepClone } from '@/utils/clone';

/** Apply validated configuration through the same history as placement and rotation. */
export function configureTile<T extends object>(instance: TileInstance<T>, editor: IChipEditorModel, patch: Partial<T>, description: string) {
  const circuit = editor.currentCircuitEditor;
  const tiles = circuit.circuitModel.tileManagerModel;
  if (tiles.get(Point.fromData(instance.location))?.id !== instance.id) return; // Dialog's tile was removed or editor changed.
  const previous: Partial<T> = {};
  for (const key of Object.keys(patch) as (keyof T)[]) previous[key] = deepClone(instance.state[key]);
  const next = deepClone(patch);
  if (JSON.stringify(previous) === JSON.stringify(next)) return;
  const apply = (value: Partial<T>) => {
    const target = tiles.get(Point.fromData(instance.location));
    if (target?.id === instance.id) Object.assign(target.state as object, deepClone(value));
  };
  circuit.runAction({ type: ActionType.ConfigureTile, description, do: () => apply(next), undo: () => apply(previous) }, description);
}
